<div class="dialog-content-min">
    <form [formGroup]="countryform">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="countryname" class="required-label">Country Name<span class="maxchars">(Max 50 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="countryname" inputId="countryname"
                    placeholder="Enter Country Name" name="countryname" formControlName="countryname" required>
                <span class="errormessage"
                    *ngIf="countryform.get('countryname').invalid && (countryform.get('countryname').dirty || countryform.get('countryname').touched)">
                    {{ getErrorMessage(countryform, validation_message, 'countryname') }}
                </span>
            </div>

        </div>

        <div class="field col-12" *ngIf="isEdit">
            <label for="activeflag" class="required-label">Active Flag<span>*</span></label> 
            <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body" name="activeflag"
                optionLabel="labelname" optionValue="value" placeholder="Select Flag"
                formControlName="activeflag"></p-dropdown>

            <span class="label-invalidmessage"
                *ngIf="countryform.get('activeflag').invalid && countryform.get('activeflag').touched">
                {{getErrorMessage(countryform, validation_message, 'activeflag')}}
            </span>
        </div>
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="closemodal(countryform,this.ref,'Are you sure, you want to close?')"></p-button>
        <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave" (click)="add()">
        </p-button>
    </div>
</div>